import { render, staticRenderFns } from "./EstBarras.vue?vue&type=template&id=bac6c4f0"
import script from "./EstBarras.vue?vue&type=script&lang=js"
export * from "./EstBarras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports